import Application from "../../Application";
import { ICaseDecision } from "../model/CaseDecision";
import { IInvalidatedCaseDecision } from "../model/InvalidatedCaseDecision";
import { ICaseDecisionService } from "../service/CaseDecisionService";

export default class CreateCaseDecisionInteractor {
  private application: Application;
  private caseDecisionService: ICaseDecisionService;

  constructor({ application, caseDecisionService }: any) {
    this.application = application;
    this.caseDecisionService = caseDecisionService;
  }

  async execute(
    item: ICaseDecision,
    indexes: number[],
    courtCase: any = undefined,
    invalidatedCaseDecisions?: IInvalidatedCaseDecision
  ) {
    return this.caseDecisionService.createCaseDecision(
      item,
      indexes,
      courtCase,
      invalidatedCaseDecisions
    );
  }
}
